export default __webpack_public_path__ + "static/media/visibility_24px_outlined.a7610c01.svg";